<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on, attrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="attrs"
        :parent-on="on"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        @activate="onButtonActivate"
      />
    </template>

    <v-form ref="form">
      <v-card>
        <v-card-title>Assay</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="pa-1">
                <v-col>
                  <v-text-field
                    v-model="ass.name"
                    label="Name"
                    hint="Assay name"
                    persistent-hint
                    :rules="nameRules"
                    @input="checkName"
                  />
                </v-col>
                <v-col>
                  <ClearableSelect
                    v-model="ass.category"
                    label="Category"
                    :items="categories"
                    hint="Assay category"
                    persistent-hint
                  />
                </v-col>
              </v-col>
            </v-row>
          </v-container>
          <v-progress-linear
            v-if="uploading"
            indeterminate
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="dialog = false"
            aria-label="Close"
          >
            Close
          </v-btn>
          <v-btn
            @click="onOk"
            aria-label="Save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { TOXPRINTS_URL } from '@/main'
import ActivatorButton from '@/components/ActivatorButton.vue'
import ClearableSelect from '@/components/ui/ClearableSelect.vue'
import { showErrorToast } from '@/utils/toast'

export default {
  components: { ActivatorButton, ClearableSelect },
  mixins: [DialogBase],

  props: {
    assay: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    ass: {
      name: null,
      category: null,
    },
    uploading: false,
    rules: {
      required: (value) => !!value || 'Required',
      min: (v) => v != null && (v.length >= 6 || 'Min 6 characters'),
    },
    checks: {},
  }),

  computed: {
    editMode() {
      return !!this.assay.id
    },
    nameRules() {
      return [this.rules.required, this.rules.min, this.nameCheck]
    },
    nameCheck() {
      return (this.editMode && this.ass.name === this.assay.name) || !this.checks.name || this.checks.name
    },
  },

  watch: {
    dialog(val) {
      if (val) Object.assign(this.ass, this.assay)
    },
  },

  methods: {
    checkName() {
      this.$axios.get(`${TOXPRINTS_URL}/assays/check?name=${encodeURIComponent(this.ass.name)}`).then((response) => {
        this.checks = response.data
      })
    },
    onOk() {
      if (this.$refs.form.validate()) {
        this.uploading = true
        // this.ass.metrics = this.ass.metrics.filter((m) => m.CTE);
        if (this.editMode) {
          this.$axios
            .put(`${TOXPRINTS_URL}/assays/${this.assay.id}`, this.ass)
            .then((response) => {
              this.$emit('assayUpdated', response.data)
              this.dialog = false
            })
            .catch((error) => {
              showErrorToast(error)
            })
            .finally(() => {
              this.uploading = false
            })
        } else {
          this.$axios
            .post(`${TOXPRINTS_URL}/assays`, this.ass)
            .then((response) => {
              this.$emit('assayCreated', response.data)
              this.dialog = false
            })
            .catch((error) => {
              showErrorToast(error)
            })
            .finally(() => {
              this.uploading = false
            })
        }
      }
    },
  },

  mounted() {
    Object.assign(this.ass, this.assay)
  },
}
</script>
